import * as React from 'react';
const SvgArrowLeftFromLine = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M10.893 15.178c.2-.2.2-.51 0-.71l-1.48-1.472h6.09c.28 0 .5-.22.5-.5v-1.001c0-.28-.22-.5-.5-.5h-6.09l1.48-1.472c.2-.2.2-.51 0-.71l-.71-.711c-.2-.2-.51-.2-.71 0l-3.18 3.182a.997.997 0 0 0 0 1.412l3.18 3.182c.2.2.51.2.71 0l.71-.71zM18.273 4.04a.52.52 0 0 0-.22.22c-.03.06-.05.14-.05.25V19.2c0 .28 0 .42.05.53.05.09.12.17.22.22.06.03.12.04.22.05h.99c.11 0 .19-.02.25-.05a.52.52 0 0 0 .22-.22c.03-.05.04-.11.05-.18V4.8c0-.28 0-.42-.05-.53a.5.5 0 0 0-.22-.22c-.11-.05-.25-.05-.53-.05h-.4c-.28 0-.42 0-.53.05z"
    />
  </svg>
);
export default SvgArrowLeftFromLine;
